import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useHomeCareProvider(countySlug: string, slug: string) {
  return useQuery({
    queryKey: ["home-care-provider", countySlug, slug],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("home_care_providers")
        .select("*")
        .eq("county_slug", countySlug)
        .eq("slug", slug)
        .eq("is_active", true)
        .maybeSingle();

      if (error) throw error;
      return data;
    },
    enabled: !!countySlug && !!slug,
  });
}
